import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

function UpdateCoOwnerModal({
  createInput,
  createTelephoneNumber,
  formData,
  getLandOwnerList,
  setFormData,
  getSingleLandOwner,
  coOwner,
  updateCoOwner,
  history,
}) {

  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    updateCoOwner(formData, () => {
      setModal({ isOpen: false });
      getLandOwnerList();
      history.push(`/rpt/land/land-owner/${formData.rptax_land_owner_id}`);
      getSingleLandOwner(formData.rptax_land_owner_id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    setFormData(coOwner);
  };

  useEffect(() => {
    onSetFormData();
  }, {});

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'address', label: 'Address:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createTelephoneNumber(
              { key: 'telephone_no', label: 'Telephone No.:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'tin', label: 'TIN:' },
              { required: true }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateCoOwnerModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createTelephoneNumber: PropTypes.instanceOf(Function).isRequired,
  coOwner: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  updateCoOwner: PropTypes.instanceOf(Function).isRequired,
  getLandOwnerList: PropTypes.instanceOf(Function).isRequired,
  getSingleLandOwner: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateCoOwnerModal);
